<template>
	<div>
		<mobileMenu></mobileMenu>
		<div class="d-none d-md-flex d-sm-flex">
			<v-app-bar class="d-flex justify-space-around white" height="125px;">
				<!-- to getback to old design all you have to do is get ride of column and rows-->
				<v-row>
					<v-col md="12">
						<v-img
							src="../Photos/Logo/RMA-logo-flat.jpg"
							height="125"
							width="175"
							v-on:click="reroute()"
						></v-img>
					</v-col>
				</v-row>

				<v-row>
					<v-col md="12">
						<v-btn
							v-for="tab in tabName"
							:key="tab.id"
							text
							class="font-weight-light mx-2"
							route
							:to="tab.src"
							exact
							inline-block
						>
							<span class="text-uppercase" text>{{ tab.title }}</span>
						</v-btn>

						<v-btn
							v-for="tab in tabName2"
							:key="tab.id"
							text
							class="font-weight-light mx-2"
							route
							:to="tab.src"
							exact
							inline-block
						>
							<span class="text-uppercase" text>{{ tab.title }}</span>
						</v-btn>
						<v-btn
							text
							class="font-weight-light mx-2"
							route
							to="/Calendar"
							exact
							inline-block
						>
							<span class="text-uppercase" text
								><v-icon>mdi-calendar</v-icon></span
							>
						</v-btn>
						<v-btn
							text
							class="font-weight-light mx-2"
							route
							to="/TyingVideos"
							exact
							inline-block
						>
							<span class="text-uppercase" text
								><v-icon>video_library</v-icon></span
							>
						</v-btn>
						<!--Account Dialog -->
						<v-menu offset-y>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									text
									icon
									tile
									class="font-weight-light pa-2 mx-2"
								>
									<span class="text-lowercase font-weight-light" text>
										<v-icon>mdi-account</v-icon>
									</span>
								</v-btn>
							</template>
							<v-list class="pa-2">
								<v-list-item>
									<v-btn @click="on = false" block text
										><v-icon class="font-weight-light">close</v-icon></v-btn
									>
								</v-list-item>
								<v-list-item v-show="showLogin">
									<v-btn
										@click="dialogLogin = true"
										block
										text
										class="text-uppercase font-weight-light"
										>Login</v-btn
									>
								</v-list-item>
								<v-list-item v-show="show" v-for="link in links" :key="link.id">
									<v-btn
										text
										route
										:to="link.src"
										block
										@click="dialogAccount = false"
									>
										<span class="text-uppercase font-weight-light">{{
											link.title
										}}</span>
									</v-btn>
								</v-list-item>
								<v-list-item v-show="show">
									<v-btn text route to="/" block v-on:click="logout">
										<span class="text-uppercase font-weight-light">
											Log Out
										</span>
									</v-btn>
								</v-list-item>
							</v-list>
						</v-menu>
						<!--login Dialog -->
						<v-dialog width="500" v-model="dialogLogin">
							<v-card>
								<v-card-title class="headline grey lighten-2" primary-title>
									Log In
								</v-card-title>
								<v-form class="pa-2" ref="form">
									<v-text-field
										placeholder="Enter Email"
										v-model="email"
									></v-text-field>
									<v-text-field
										placeholder="Enter Password"
										v-model="password"
										type="password"
									></v-text-field>
									<v-btn @click="login" to="/"> LogIn </v-btn>
									<v-card-text>
										Dont have a account?
										<v-btn
											class="font-weight-light"
											route
											to="/SignUp"
											text
											@click="
												dialogLogin = false;
												dialogAccount = false;
											"
											>Sign Up Here</v-btn
										>
										<br />
										Forgot Password?
										<v-btn
											class="font-weight-light"
											route
											to="/Forgot"
											text
											@click="
												dialogLogin = false;
												dialogAccount = false;
											"
											>Reset</v-btn
										>
									</v-card-text>
									<!--<v-card-text> Forgot Password? <v-btn class="font-weight-light" route to="/Forgot" text @click="dialogLogin=false; dialogAccount=false">Reset</v-btn></v-card-text>-->
									<p class="red--text lighten-2">{{ error }}</p>
								</v-form>
							</v-card>
						</v-dialog>
					</v-col>
				</v-row>
			</v-app-bar>
			<!--app makes it stationary at the top-->
		</div>
	</div>
</template>

<script>
import fb from "@/fb";
import mobileMenu from "../components/mobileMenu.vue";
export default {
	components: {
		mobileMenu,
	},

	data() {
		return {
			dialogAccount: false,
			dialogLogin: false,
			showLogin: true,
			addLinks: [],
			show: false,
			links: [],
			email: "",
			password: "",
			error: "",
			on: false,
			tabName: [
				{ id: 1, title: "Home", src: "/" },
				{ id: 5, title: "Guided Trips", src: "/GuideTrips" },
				{ id: 7, title: "Events", src: "/Events" },
				{ id: 8, title: "Classes", src: "/Classes" },
			],
			tabName2: [
				{ id: 10, title: "Kids Camp", src: "/Camp" },
				{ id: 9, title: "River Reports", src: "/RiverReports" },
				{ id: 6, title: "Blog", src: "/Blog" },
			],
		};
	},
	methods: {
		reroute: function() {
			window.location.replace("/");
		},
		logout: function() {
			fb.auth
				.signOut()
				.then(() => {
					this.show = false;
					this.dialog = false;
					this.showLogin = true;
					console.log("user signed out");
				})
				.then(() => {
					this.show = false;
				});
			this.show = false;
			this.dialogAccount = false;
			this.showLogin = true;
		},
		login() {
			fb.auth
				.signInWithEmailAndPassword(this.email, this.password)
				.then((cred) => {
					if (cred.user && cred.user.emailVerified == true) {
						this.dialogLogin = false;
						this.$refs.form.reset();
						this.showLogin = false;
					} else {
						this.error = "You have not verified your email";
					}
				})
				.catch((err) => {
					err = "Your username or password does not match any records";
					this.error = err;
				});
			console.log("logged in!");
		},
	},
	created() {
		fb.auth.onAuthStateChanged((user) => {
			if (user && user.emailVerified == true) {
				user.getIdTokenResult().then((idTokenResult) => {
					if (idTokenResult.claims.admin == true) {
						this.links = [
							{ id: 1, title: "Event Actions", src: "/EventActions/Add" },
							{ id: 2, title: "Update River Report", src: "/UpdateRR" },
							{ id: 3, title: "Employee Actions", src: "/AddEmployee" },
							{ id: 4, title: "Blog Actions", src: "/AddBlog" },
							{
								id: 5,
								title: "Annnouncement Actions",
								src: "/AddAnnouncements",
							},
							{
								id: 6,
								title: "Specialty Trip Actions",
								src: "/SpecialtyTrips",
							},
							{ id: 7, title: "My Account", src: "/Account" },
						];
					} else {
						this.links = [{ id: 1, title: "My Account", src: "/Account" }];
					}
				});
				this.show = true;
			}
		});
	},
	beforeUpdate() {
		fb.auth.onAuthStateChanged((user) => {
			if (user) {
				this.show = true;
				this.showLogin = false;
			} else {
				this.show = false;
				this.showLogin = true;
				//console.log("Heyyo-buddy")
			}
		});
	},
};
</script>
<style scoped>
router-link {
	text-decoration: none;
}
.bg {
	background-position: center;
	background-size: cover;
}
.bg2 {
	border-top: 1px solid black;
	border-bottom: 1px solid black;
	background-color: transparent;
}
.imgbg {
	border: 1px solid black;
	border-radius: 100%;
}
</style>
